// extracted by mini-css-extract-plugin
export default {"container":"NoSearchResults_container__u697d","backGround":"NoSearchResults_backGround__E1b1d"};